export default {
  resource: {
    zh: {
      title: "补卡",
      companyNo:"公司",
      empId:"员工编号",
      empName:"姓名",
      filingTimeF:"审核通过开始日期",
      filingTimeT:"审核通过结束日期",
      deptNo:"部门",
      status:"状态",
      flowCourseId: "流水号",
      apply_dept: "申请部门",
      account: "申请人编号",
      bkrq: "补卡日期",
      bksjd: "补卡时间段",
      toPAsign:"转考勤标记",
      name: "申请人名字",
      apply_des_auditing: "申请审核人",
      day_hope_finish: "期望修复时间",
      deal_dept: "处理部门",
      day_repeat_finish: "预计修复时间",
      deal_remark: "维修描述",
      deal_auditing_user: "申请处理人",
      deal_user: "维修人",
      day_finish: "修复时间",
      remark: "复核",
      confirm_user: "复核人",
      state: "未用",
      adderId: "登录用户ID",
      addTime: "添加记录时间",
      canuse: "未用",
      apply_img: "未用",
      deptName:"部门名称",
      result_img: "未用"
    }
  },
  delConf: ["account"],
  delKeys: ["account"],
  isShowMore: true,
  params: {
    companyNo:{
      key: "companyNo",
      defaultIdx: 0,
      method: "Equal",
      type: "select",
      options:"company"
    },
    
    empName:{
      key: "empName",
      data: null,
      method: "Contains",
      type: "text"
    },
    empId:{
      key: "empId",
      data: null,
      method: "Equal",
      type: "text"
    },
   
    filingTimeF: {
      key: "filingTime",
      tkey: "filingTimeF",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date",
    },
    filingTimeT: {
      key: "filingTime",
      tkey: "filingTimeT",
      data: null,
      method: "LessThanOrEqual",
      type: "date",
    },
  
 
    status: {
      key: "status",
      data: "2",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }, {
        value: "1",
        text: "已转"
      }, {
        value: "2",
        text: "未转"
      }]
    },
    dept: {
      key: "deptNo",
      data: "",
      method: "Equal",
      type: "select",
      more: true,
      options: [{
        value: "",
        text: "All"
      }]
    }
   
  
    
  },
  listDefine: [
    {key:"flowCourseId",width:"120px"},{key:"deptName",width:"120px"},
     {key:"account",width:"120px"},{key:"name",width:"120px"},
    {key:"bkrq", width:"130px"},  {key:"bksjd",  width:"130px"}, {key:"toPAsign",  width:"60px"}
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "account",
  defaultSortOrder: "desc",
  sortName: "account",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount:127,
  url: "buka/",
  autoId: "account"
}
